import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import type { StudyResults } from "@/types/api";
import { TrendingUp } from "lucide-react";
import { lazy, Suspense } from 'react';

// Lazy load the actual Plotly component
const ParameterContourPlot = lazy(() => import('./ParameterContourPlot'));

interface ParameterContourPlotLazyProps {
  results: StudyResults;
  onParameterSelect?: (xParam: string, yParam: string) => void;
}

function ParameterContourPlotFallback() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TrendingUp className="h-5 w-5" />
          Parameter Landscape (2D Contour)
        </CardTitle>
        <CardDescription>
          Visualize the optimization landscape between any two parameters
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[500px] flex items-center justify-center">
          <div className="text-center space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="text-sm text-muted-foreground">
              Loading parameter visualization...
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default function ParameterContourPlotLazy({ results, onParameterSelect }: ParameterContourPlotLazyProps) {
  return (
    <Suspense fallback={<ParameterContourPlotFallback />}>
      <ParameterContourPlot results={results} {...(onParameterSelect && { onParameterSelect })} />
    </Suspense>
  );
}
